<template>
  <nav :class="`dn-local-navi dn-local-navi--${id}`" v-if="data">
    <h3 class="dn-local-navi__ttl" v-html="label"></h3>
    <div class="dn-local-navi__body">
      <template
        v-for="group in groups"
      >
        <span
          v-if="group.label"
          :key="group.id + '-label'"
          class="dn-local-navi__link dn-local-navi__label"
          v-html="group.label"
        ></span>
        <a
          v-for="link in group.links"
          :key="link.id"
          class="dn-local-navi__link"
          :class="{'dn-local-navi__link--active': link.matched}"
          :href="link.href"
          :target="link.target"
          v-linkset="link.url_id"
        >
          <span v-html="link.label"></span>
          <span class="dn-icon dn-icon-arrow-right"></span>
        </a>
      </template>
    </div>
  </nav>
</template>



<script>
export default {
  name: 'dn-local-navi',

  computed: {
    data() { return this.$store.getters['navigation/localNaviCategory'] },
    id() { return this.data && this.data.id },
    label() { return this.data && this.data.label },
    groups() { return this.data && this.data.groups },
  },
}
</script>



// WEBPACK FOOTER //
// LocalNavi.vue?2c05bdbe